import React from "react";
import type { IconProps } from "./type";
import { COLORS } from "@/app/common/consts/colors";

const Google = ({ color = "offWhite" }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 28 28"
      fill="none"
      className="w-3 h-3 sm:w-6 sm:h-6"
    >
      <path
        d="M3.23409 9.48542C4.06757 7.48953 5.43969 5.76476 7.19709 4.50388C8.95449 3.24301 11.0279 2.49571 13.1856 2.34551C16.3221 2.12618 19.0377 3.09528 21.1836 4.83282L18.0803 8.40399C16.7928 7.33504 15.2178 6.85457 13.5093 6.97404C10.4775 7.18604 8.05451 9.41382 7.33321 12.2278C7.14928 12.9424 7.06869 13.6965 7.1224 14.4646C7.17611 15.2328 7.36087 15.9683 7.64247 16.6504C8.74962 19.3377 11.4578 21.2055 14.4896 20.9935C16.055 20.884 17.3586 20.3777 18.3526 19.6065C18.9293 19.1662 19.4107 18.6135 19.7678 17.9819C20.1248 17.3502 20.3501 16.6528 20.43 15.9316L14.1663 16.3696L13.8515 11.8679L24.8124 11.1015C25.0029 11.853 25.1329 12.6415 25.1906 13.4667C25.4385 17.0117 24.3786 20.0844 22.3183 22.2635C20.5177 24.1764 17.9556 25.4023 14.8133 25.622C13.2848 25.7295 11.7501 25.5347 10.2969 25.0488C8.84374 24.5629 7.50056 23.7954 6.34415 22.7902C5.18773 21.7849 4.24076 20.5616 3.55734 19.1902C2.87392 17.8188 2.46746 16.3262 2.36119 14.7976C2.22984 12.9192 2.55489 11.1118 3.23409 9.48542Z"
        fill={COLORS[color]}
      />
    </svg>
  );
};

export default Google;
